import * as React from 'react';
import { useTranslation } from 'react-i18next';

import {
  Icon,
  useWindowDimensions,
} from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink } from '@uncinc/react-drupal-core';

import { SCREEN_WIDE } from '../../config/constants';

import './style.scss';

interface BreadcrumbsProps {
  parentLink?: string;
  parentTitle?: string;
  currentPage: string;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  parentLink,
  parentTitle,
  currentPage,
}) => {
  const { t } = useTranslation();

  const { width } = useWindowDimensions();
  const isSmall = width < SCREEN_WIDE;

  return (
    <div className="Breadcrumbs">
      <div className="Breadcrumbs__home">
        <CoreLink className="Breadcrumb" href="/">{t('general.home')}</CoreLink>
        <Icon name="chevron_right" />
      </div>
      {parentLink && (
        <div className="Breadcrumbs__parent">
          <CoreLink className="Breadcrumb" href={parentLink}>{parentTitle}</CoreLink>
          <Icon name={`${isSmall ? 'arrow_back' : 'chevron_right'}`} />
        </div>
      )}
      <div className="Breadcrumbs__current">
        {currentPage}
      </div>
    </div>
  );
};

export default Breadcrumbs;
